import { NPSLowRatingReason, NPSRatingCategory } from './models';

export const NPS_POST_SUBMISSION_REVIEW_URL = 'https://www.g2.com/contributor/hevodata_rl-25_g2?secure%5Bpage_id%5D=hevodata_rl-25_g2&secure%5Brewards%5D=true&secure%5Btoken%5D=927de059d569844787afe215dde44c2c1152915eb90819d63f6f1e30af967f09';
export const NPS_POST_SUBMISSION_REVIEW_LOGO = 'https://res.cloudinary.com/hevo/image/upload/v1680637522/dashboard/Logos_g2_bqvzgi.svg';
export const NPS_SCHEDULE_CALL_LINK = 'https://meetings.hubspot.com/hevodata/nps';
export const NPS_POST_SUBMISSION_REVIEW_LABEL = 'G2';

export const RATING_STAR_IMAGES = {
  1: 'https://res.cloudinary.com/hevo/image/upload/v1715270307/dashboard/rating-1_qz6xyg.svg',
  2: 'https://res.cloudinary.com/hevo/image/upload/v1715270306/dashboard/rating-2_x3f4r0.svg',
  3: 'https://res.cloudinary.com/hevo/image/upload/v1715270308/dashboard/rating-3_ddhbch.svg',
  4: 'https://res.cloudinary.com/hevo/image/upload/v1715270307/dashboard/rating-4_qgiyro.svg',
  5: 'https://res.cloudinary.com/hevo/image/upload/v1715270307/dashboard/rating-5_pdjwsm.svg',
  6: 'https://res.cloudinary.com/hevo/image/upload/v1715270306/dashboard/rating-6_jswxmz.svg',
  7: 'https://res.cloudinary.com/hevo/image/upload/v1716190787/dashboard/rating-7_uytifp.svg',
  9: 'https://res.cloudinary.com/hevo/image/upload/v1661186305/dashboard/rating-ty-09_rsy0sb.svg',
  10: 'https://res.cloudinary.com/hevo/image/upload/v1661186305/dashboard/rating-ty-10_nabcel.svg'
};

export const NPS_LOW_RATING_REASONS: NPSLowRatingReason[] = [
  {
    name: 'Pricing',
    value: 'PRICING'
  },
  {
    name: 'Product Issue',
    value: 'PRODUCT_ISSUE'
  },
  {
    name: 'Feature Gaps',
    value: 'FEATURE_GAPS'
  },
  {
    name: 'Support',
    value: 'SUPPORT'
  },
  {
    name: 'Others',
    value: 'OTHERS'
  }
];

export const NPS_RATING_CATEGORY_METADATA = {
  [NPSRatingCategory.NOT_LIKELY]: {
    title: 'What was missing or disappointing in your experience with Hevo? 😣',
    commentPlaceholder: 'Let it out. We\'re Listening!',
    commentLabel: 'Additional Feedback',
    reasonPlaceholder: 'Select one or more reasons',
    commentRequired: true,
    showReason: true,
    requiredReasonHelpText: 'Please select one or more reasons.',
    requiredCommentHelpText: 'Please provide additional feedback.'
  },
  [NPSRatingCategory.AVERAGE]: {
    title: 'What is the one thing you would like us to improve upon? 🙁',
    commentPlaceholder: 'Tell us first thing that comes to your mind…',
    commentLabel: 'Additional Feedback',
    reasonPlaceholder: 'Select improvement areas',
    commentRequired: true,
    showReason: true,
    requiredReasonHelpText: 'Please select one or more improvement areas.',
    requiredCommentHelpText: 'Please provide additional feedback.'
  },
  [NPSRatingCategory.LIKELY]: {
    title: 'What do you love about Hevo? 😍',
    commentPlaceholder: 'Your words are our badge of honor.',
    commentLabel: undefined,
    reasonPlaceholder: undefined,
    commentRequired: false,
    showReason: false,
    requiredReasonHelpText: undefined,
    requiredCommentHelpText: undefined
  }
};
